module.exports = __webpack_public_path__ + "static/media/webview-img3.670062ed.png";